/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Filter_ClosedInputs */

const en_cases_filter_closed = /** @type {(inputs: Cases_Filter_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closed`)
};

const pt_br2_cases_filter_closed = /** @type {(inputs: Cases_Filter_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechado`)
};

/**
* | output |
* | --- |
* | "Closed" |
*
* @param {Cases_Filter_ClosedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_filter_closed = /** @type {((inputs?: Cases_Filter_ClosedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Filter_ClosedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_filter_closed(inputs)
	return pt_br2_cases_filter_closed(inputs)
});